export const SUGGEST_PROMPT_TYPES = {
  improve: 'improve_prompt',
  personalize: 'personalize_prompt',
} as const;
export type SuggestPromptType = (typeof SUGGEST_PROMPT_TYPES)[keyof typeof SUGGEST_PROMPT_TYPES];

export const PROMPT_ACTION = {
  insertBrandBrief: Symbol('insert_brand_brief'),
  insertUrl: Symbol('insert_url'),
  insertExternalChannelItems: Symbol('insert_external_channel_items'),
  insertVariable: Symbol('insert_variable'),
  insertInstruction: Symbol('insert_instruction'),

  validateResourceLimit: Symbol('validate_resource_limit'),
  insertFileResource: Symbol('insert_file_resource'),
  uploadResourceFile: Symbol('upload_resource_file'),
  removeFileResource: Symbol('remove_file_resource'),
  errorUploadingFile: Symbol('error_uploading_file'),

  addBrandBrief: Symbol('add_brand_brief'),
  openResourceInNewTab: Symbol('open_resource_in_new_tab'),
  suggestPrompt: Symbol('suggest_prompt'),
  savePrompt: Symbol('save_prompt'),
  clearVariationRatings: Symbol('clear_variation_ratings'),

  displayMessage: Symbol('display_message'),
  trackEvent: Symbol('track_event'),
} as const;
export type PromptAction = (typeof PROMPT_ACTION)[keyof typeof PROMPT_ACTION];
